export const de = {
  // --- FRUITS ---
  apple: ['apfel', 'äpfel', 'granny smith', 'elstar'],
  banana: ['banane', 'bananen'],
  cherry: ['kirsche', 'kirschen', 'sauerkirsche'],
  grape: ['traube', 'weintraube', 'rosinen'],
  citrus: ['citrus', 'limette', 'mandarine', 'clementine', 'pampelmuse', 'grapefruit'],
  orange: ['orange', 'orangen'],
  lemon: ['zitrone', 'zitronen'],
  pear: ['birne', 'birnen'], // NEW
  melon: ['melone', 'wassermelone', 'honigmelone'],
  pineapple: ['ananas'],
  avocado: ['avocado'],
  berry: ['beere', 'erdbeere', 'blaubeere', 'himbeere', 'johannisbeere', 'heidelbeere'],
  fruit: ['obst', 'frucht', 'kiwi', 'pflaume', 'feige', 'granatapfel', 'aprikose'],
  peach: ['pfirsich', 'nektarine'],
  mango: ['mango'],
  jam: ['marmelade', 'konfitüre', 'fruchtaufstrich', 'gelee', 'erdbeermarmelade', 'himbeermarmelade', 'aprikosenmarmelade'],
  honey: ['honig'],

  // --- VEGETABLES ---
  carrot: ['karotte', 'karotten', 'möhre', 'möhren', 'rübe', 'rüben'],
  corn: ['mais', 'maisdose', 'maisgries'],
  salad: ['salat', 'kopfsalat', 'feldsalat', 'rucola', 'eisberg'],
  spinach: ['spinat', 'blattspinat'],
  mushroom: ['pilz', 'pilze', 'champignon', 'champignons', 'steinpilz', 'steinpilze', 'pfifferling', 'pfifferlinge'],
  onion: ['zwiebel', 'zwiebeln', 'schalotte', 'schalotten', 'lauchzwiebel', 'lauchzwiebeln'],
  fried_onions: ['röstzwiebeln'],
  garlic: ['knoblauch'], // NEW
  leek: ['lauch', 'porree'],
  potato: ['kartoffel', 'kartoffeln', 'kroketten', 'süßkartoffel', 'süßkartoffeln'],
  fries: ['pommes', 'fritten', 'pommes frites'],
  tomato: ['tomate', 'tomaten', 'fleischtomate', 'fleischtomaten', 'passierte tomaten'],
  cherry_tomatoes: ['kirschtomate', 'kirschtomaten', 'cocktailtomate', 'cocktailtomaten'],
  pepper: ['paprika', 'paprikaschote', 'chili', 'jalapeno', 'peperoni'],
  veg: ['gemüse', 'kohl', 'kürbis'],
  cabbage: ['weisskohl', 'weißkohl'],
  celery: ['sellerie', 'stangensellerie', 'knollensellerie'],
  sprouts: ['sprossen', 'sojasprossen', 'kresse'],
  pak_choi: ['pak choi', 'senfkohl'],
  broccoli: ['brokkoli'],
  cucumber: ['gurke', 'gurken'],
  pickles: ['essiggurken', 'gewürzgurken'],
  zucchini: ['zucchini'],
  cauliflower: ['blumenkohl'],
  soup_greens: ['suppengrün', 'suppengemüse'],
  peas: ['erbse', 'erbsen', 'kaisergemüse', 'kichererbsen'],
  snow_peas: ['schneeerbsen', 'zuckerschoten', 'kefen'],
  bean: ['bohne', 'bohnen', 'erbsen tk'], // NEW
  lentils: ['linsen'],
  beetroot: ['rote beete', 'rote rübe'],
  sauerkraut: ['sauerkraut'],

  // --- DAIRY & EGGS ---
  milk: ['milch', 'vollmilch', 'h-milch', 'alpenmilch', 'sojamilch', 'mandelmilch', 'buttermilch'],
  oatmilk: ['hafermilch'],
  cheese: ['käse', 'gouda', 'emmentaler', 'mozzarella', 'parmesan', 'feta', 'camembert', 'brie', 'cheddar', 'gorgonzola', 'frischkäse', 'quark', 'mascarpone'],
  egg: ['ei', 'eier', 'freilandeier', 'bio-eier', 'eigelb', 'eiweiß'],
  butter: ['butter', 'kräuterbutter'],
  yogurt: ['joghurt', 'fruchtjoghurt', 'naturjoghurt', 'skyr', 'kefir', 'sojajoghurt'],
  dairy: ['pudding', 'milchreis', 'zartbitter schokoraspel'],
  cream: ['sahne', 'schlagsahne', 'sprühsahne', 'kochsahne'],
  sour_cream: ['schmand', 'creme fraiche', 'sauerrahm', 'saure sahne'],

  // --- BAKERY ---
  bread: ['brot', 'vollkornbrot', 'graubrot', 'weißbrot', 'toast'],
  rolls: ['brötchen', 'semmel', 'schrippe', 'weckle', 'hotdog brötchen'],
  burger_bun: ['burger brötchen', 'hamburger brötchen', 'bun', 'brioche bun'],
  baguette: ['baguette', 'ciabatta'],
  croissant: ['croissant', 'hörnchen', 'schokocroissant'],
  cookie: ['keks', 'cookies', 'plätzchen', 'biskuit', 'doppelkeks'],
  cake: ['kuchen', 'torte', 'muffin', 'cupcake', 'berliner', 'krapfen', 'donut', 'stollen', 'mohn'],
  flammkuchen_base: ['flammkuchenböden', 'flammkuchenboden'],
  pizza: ['pizza', 'pizzateig', 'piccolinis', 'flammkuchen'],
  sandwich: ['sandwich', 'burger', 'cheeseburger'],
  flour: ['mehl', 'weizenmehl', 'speisestärke', 'hefe', 'paniermehl', 'sahnesteif', 'vanillezucker'],
  baking_powder: ['backpulver', 'natron'],

  // --- MEAT & FISH ---
  meat: ['fleisch', 'rind', 'schwein', 'lamm', 'kalb', 'steak', 'gulasch', 'hackfleisch', 'mett', 'hack', 'veganes hack'],
  bbq_meat: ['grillfleisch', 'steak', 'nackensteak', 'grillfackel', 'minutensteak'],
  tofu: ['tofu', 'seitan', 'tempeh'],
  chicken: ['hähnchen', 'hühnchen', 'pute', 'geflügel', 'chicken', 'hähnchenbrust'],
  fish: ['fisch', 'forelle', 'kabeljau', 'zander'],
  fish_sticks: ['fischstäbchen'],
  tuna: ['thunfisch'],
  salmon: ['lachs', 'lachsfilet'],
  seafood: ['garnelen', 'scampi', 'shrimps', 'muscheln', 'tintenfisch'],
  sausage: ['wurst', 'wiener', 'bratwurst', 'bockwurst', 'leberwurst', 'salami', 'schinkenwurst', 'mortadella', 'vegane leberwurst', 'hotdog würstchen'],
  bacon: ['speck', 'bacon', 'schinken', 'prosciutto', 'frühstücksspeck'],
  bacon_cubes: ['speckwürfel', 'katenschinken'],
  meatballs: ['geflügelbällchen', 'kötbollar', 'fleischbällchen', 'gemüsebällchen', 'hackbällchen'],

  // --- PANTRY & GRAINS ---
  rice: ['reis', 'basmati', 'jasminreis', 'milchreis', 'risotto', 'risotto reis'],
  pasta: ['nudeln', 'penne', 'fusilli', 'farfalle', 'makkaroni'],
  spaghetti: ['spaghetti'],
  tortellini: ['tortellini', 'ravioli', 'gnocchi', 'spätzle', 'maultaschen'],
  lasagna: ['lasagne', 'lasagneplatten'],
  noodles: ['mie-nudeln', 'glasnudeln', 'ramen'],
  cereal: ['müsli', 'haferflocken', 'cornflakes', 'porridge', 'cerealien'],
  oil: ['öl', 'olivenöl', 'sonnenblumenöl', 'rapsöl'],
  vinegar: ['essig', 'apfelessig', 'weissweinessig', 'balsamico'],
  spice: ['salz', 'pfeffer', 'gewürz', 'paprikapulver', 'curry', 'zimt', 'vanille', 'kräuter', 'oregano'],
  parsley: ['petersilie'],
  basil: ['basilikum'],
  fresh_herbs: ['frische kräuter'],
  coriander: ['koriander', 'koriander frisch'],
  broth: ['gemüsebrühe', 'brühe', 'hühnerbrühe', 'fleischbrühe', 'suppenwürfel'],
  sugar: ['zucker', 'rohrozucker', 'süssstoff', 'honig', 'ahornsirup', 'sirup'],
  powdered_sugar: ['puderzucker'],
  canned: ['dose', 'konserve', 'kokosmilch', 'gekocktes sauerkraut', 'erbsen tiefgekühlt'], // removed beans/peas
  canned_tomatoes: ['dosentomaten'],
  tomato_paste: ['tomatenmark'],
  sauce: ['sauce', 'soße', 'bratensauce', 'grillsauce', 'remoulade'],
  mayo: ['mayo', 'majo', 'mayonnaise', 'majonaise'],
  ketchup: ['ketchup'],
  mustard: ['senf'],
  soy_sauce: ['sojasauce'],
  dip: ['dip', 'guacamole', 'tsatsiki', 'aioli'],
  hummus: ['hummus'],

  // --- SNACKS & SWEETS ---
  candy: ['bonbon', 'kaubonbon', 'leckerli', 'kaugummi', 'lolli', 'gummibärchen', 'gummibärchen (troll)', 'hustenbonbons', 'salbei'],
  praline: ['pralinen', 'praline', 'schachtel'],
  chocolate: ['schokolade', 'riegel', 'kinderschokolade', 'nutella', 'schokoraspel', 'backkakao', 'zartbitter schokoraspel'],
  chips: ['chips', 'stapelchips', 'tortilla', 'nachos', 'flips', 'erdnussflips'],
  pretzel_sticks: ['salzstangen', 'brezel'],
  ice_cream: ['eis', 'speiseeis', 'wassereis', 'eiscreme'],
  popcorn: ['popcorn'],
  nut: ['nuss', 'nüsse', 'haselnüsse', 'cashew', 'pistazien', 'studentenfutter', 'mandelmilch'],
  peanut: ['erdnuss', 'erdnüsse'],
  almond: ['mandel', 'mandeln'],
  walnut: ['walnuss', 'walnüsse'],

  // --- BEVERAGES ---
  water: ['wasser', 'mineralwasser', 'sprudel', 'stilles wasser', 'trinkflasche', 'trinkflaschen'],
  drinks: ['getränke', 'pfand', 'leergut'],
  coffee: ['kaffee', 'kaffeebohnen', 'kaffeepulver', 'espresso', 'cappuccino', 'kapseln', 'pads', 'kaffeefilter'],
  tea: ['tee', 'schwarztee', 'kräutertee', 'grüner tee', 'pfefferminztee', 'kamillentee'],
  tea_bags: ['teebeutel', 'erkältungstee', 'bauchwehtee'],
  soda: ['cola', 'limo', 'limonade', 'fanta', 'sprite', 'mezzo', 'spezi', 'energy drink', 'tonic', 'tonic water'],
  juice: ['saft', 'orangensaft', 'apfelsaft', 'multivitaminsaft', 'smoothie'],
  beer: ['bier', 'pils', 'weizen', 'radler', 'alkoholfreies bier', 'alkoholfreie radler', 'alkoholfreies radler'],
  wine: ['wein', 'sekt', 'prosecco', 'champagner'],
  red_wine: ['rotwein'],
  white_wine: ['weißwein', 'riesling', 'chardonnay', 'trockener weißwein'],
  alcohol: ['schnaps', 'vodka', 'gin', 'rum', 'whisky', 'likör'],

  // --- HOUSEHOLD & HEALTH ---
  toilet_paper: ['klopapier', 'toilettenpapier', 'taschentücher', 'küchenrolle'],
  soap: ['seife', 'handseife', 'duschgel'],
  cleaning: ['reiniger', 'spülmittel', 'waschmittel', 'weichspüler', 'tabs', 'schwamm', 'lappen', 'müllbeutel', 'entkalkungsmittel', 'küchenpapier'],
  napkins: ['servietten', 'taschentücher'],
  medicine: ['medikament', 'tabletten', 'pflaster', 'schmerzmittel', 'nasenspray', 'vitamine'],
  baby: ['windeln', 'babybrei', 'feuchttücher', 'schnuller'],
  pet: ['futter', 'katzenfutter', 'hundefutter', 'leckerli', 'katzenstreu'],
  flower: ['blumen', 'strauß', 'pflanze', 'erde'],
  gift: ['geschenk', 'gutschein', 'karte', 'geschenkpapier'],
  party: ['party', 'geburtstag', 'luftballons', 'kerze'],
  battery: ['batterien', 'akku'],
  trash: ['mülltüten', 'gelbe säcke'], // removed Müllbeutel (dup)
};